import { drawback } from 'redevConfig'
const list = (drawback && drawback.list) || ''
const drawbackListPage = list ? require(`redevelopment/input/drawback/${list.templateName}`) : require('./view/drawback.html')

export default {
    base: {
        state: 'input.certification.drawback',
        config: {
            url: '/drawback',
            abstract: true,
            template: '<div ui-view></div>',
            title: '退税勾选',
            default: 'input.certification.drawback.list'
        },
    },
    list: {
        state: 'input.certification.drawback.list',
        config: {
            url: '/list',
            template: drawbackListPage,
            controller: 'drawbackCtrl',
        },
    },
}



// WEBPACK FOOTER //
// ./src/app/input/specialInvoiceCertification/drawback/routers.js